import { gql } from '@apollo/client';

import { CORE_ORGANIZATION_FIELDS } from './fragments';

export const createOrganization = gql`
  ${CORE_ORGANIZATION_FIELDS}
  mutation createOrganization($input: CreateOrganizationInput!) {
    createOrganization(input: $input) {
      ...CoreOrganizationFields
    }
  }
`;

export const updateOrganization = gql`
  ${CORE_ORGANIZATION_FIELDS}
  mutation updateOrganization($input: UpdateOrganizationInput!) {
    updateOrganization(input: $input) {
      ...CoreOrganizationFields
      subscription {
        id
        expirationDate
        product {
          id
          name {
            languageCode
            value
          }
          catalogs {
            id
          }
        }
        status
        validFrom
        validTo
        seats
        invoice
      }
    }
  }
`;

export const updateFeaturedCourses = gql`
  mutation updateFeaturedCourses($input: MutateFeaturedCoursesInput!) {
    updateFeaturedCourses(input: $input) {
      id
      name {
        languageCode
        languageId
        value
      }
    }
  }
`;

export const updateSubscription = gql`
  mutation updateSubscription($input: UpdateSubscriptionInput!) {
    updateSubscription(input: $input) {
      id
      expirationDate
      product {
        id
        name {
          languageCode
          value
        }
        catalogs {
          id
        }
      }
      status
      validFrom
      validTo
      seats
      invoice
    }
  }
`;

export const updateProduct = gql`
  mutation updateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
      name {
        languageCode
        value
      }
      catalogs {
        id
      }
    }
  }
`;
